import { render, staticRenderFns } from "./detailMenu.vue?vue&type=template&id=060c169b&scoped=true&"
import script from "./detailMenu.vue?vue&type=script&lang=js&"
export * from "./detailMenu.vue?vue&type=script&lang=js&"
import style0 from "./detailMenu.vue?vue&type=style&index=0&id=060c169b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c169b",
  null
  
)

export default component.exports